import { Api } from "./Configs";

/*** 
    Export url 
***/

//ACCOOUNT
export const USERS_SESSION = ()=> `${Api}/user/datas`;
export const GET_USERS_ACCOUNT = (user)=> `${Api}/user-account/${user}`;
//PROFILE
export const USER_PROFILE_FETCH = (id, sessionId)=> `${Api}/user/${id}/${sessionId}`;
export const POST_PROFILE = (id, sessionId) => `${Api}/user/${id}/${sessionId}`;

//GESTION DE COMPTE USER
export const UPDATE_USER_ACCOUNT = (user, sessionId) => `${Api}/user/update/${user}/${sessionId}`;
export const DELETE_USER_ACCOUNT = (user)=> `${Api}/user/remove/${user.id}/${user.useruuid}`;
export const GET_ALL_USERS = (page, search)=> `${Api}/users?page=${page}&s=${search}`;

//DASHBOARD
export const COUNT_ENUM_DOCS = () => `${Api}/enum/entity`;
export const COUNT_COLLECTIONS = ()=> `${Api}/enum/collections`;
export const COUNT_USERS = ()=> `${Api}/enum/users`;

//COLLECTIONS
export const GET_PUBLIC_COLLECTIONS=()=> `${Api}/search/collections`;
export const GET_ALL_COLLECTIONS=()=> `${Api}/collections`;
export const COLLECTIONS_ADDS=()=> `${Api}/collections/adds`;
export const COLLECTIONS_DELETE=(id)=> `${Api}/collections/del/${id}`;
export const COLLECTIONS_UPDATE=(id)=> `${Api}/collections/update/${id}`;
//GENRES
export const GET_ALL_GENRES=()=> `${Api}/genres-litteraires`;
export const GENRES_ADDS=()=> `${Api}/genres/adds`;
export const GENRES_DELETE=(id)=> `${Api}/genres/del/${id}`;
export const GENRES_UPDATE=(id)=> `${Api}/genres/update/${id}`;
export const GET_PUBLIC_GENRE=()=> `${Api}/search/genres`;

//CLASSIFICATIONS
export const GET_PUBLIC_CATS=()=> `${Api}/search/classifications`;
export const GET_ALL_CAT=()=> `${Api}/classifications`;
export const CAT_ADDS=()=> `${Api}/classifications/adds`;
export const CAT_DELETE=(id)=> `${Api}/classifications/del/${id}`;
export const CAT_UPDATE=(id)=> `${Api}/classifications/update/${id}`;

//ENTITYS
export const GET_ALL_ENTITYS = (page, date, langue, type, collection, classification, genre)=> `${Api}/entitys?page=${page}&date=${date}&langue=${langue}&type=${type}&col=${collection}&cat=${classification}&g=${genre}`
export const CREATE_BIBLIO_ENTITYS = () => `${Api}/entitys/createsitems`;
export const ENTITY_DELETE=(uuid, id, fichier, type)=> `${Api}/entitys/del/${uuid}/${id}/${fichier}/${type}`;
export const GET_ENTITYS_ITEMS = (uuid, id) => `${Api}/entitys/${uuid}/${id}`;
export const ENTITYS_UPDATE_ITEMS = (uuid, id) => `${Api}/entitys/update/${uuid}/${id}`;
export const DELETE_TAGS_CATS=(id, entity)=> `${Api}/entitys/deltags/${id}/${entity}`;

//SEARCH
export const APP_SEARCH = (page, search, coll, type, cat, dt)=> `${Api}/search?page=${page}&search=${search}&collection=${coll}&type=${type}&cat=${cat}&date=${dt}`;
export const APP_HOME_SEARCH = (page, search, coll, type, cat, dt)=> `${Api}/search/home?page=${page}&search=${search}&collection=${coll}&type=${type}&cat=${cat}&date=${dt}`;
export const APP_GET_SEARCH_RESS = entity => `${Api}/search/ressources/${entity}`;
export const APP_GET_BIBLIO_ENTITY = (id, uuid) => `${Api}/search/g/e/${id}/${uuid}`;
export const APP_READ_ENTITY = (uuid, id, fichier) => `${Api}/ressources/g/r/${uuid}/${id}/${fichier}`;

// GED / Plan de classement
export const PLAN_TREE = () => `${Api}/ged/plan`;
export const PLAN_FOLDER_CREATE = () => `${Api}/ged/folders`;
export const PLAN_FOLDER_UPDATE = (id) => `${Api}/ged/plan/folder/${id}`;
export const PLAN_FOLDER_DELETE = (id) => `${Api}/ged/plan/folder/${id}`;
export const PLAN_META_LIST = () => `${Api}/ged/plan/meta`;
export const PLAN_META_CREATE = () => `${Api}/ged/plan/meta`;
export const PLAN_META_UPDATE = (id) => `${Api}/ged/plan/meta/${id}`;
export const PLAN_META_ACTIVE = () => `${Api}/ged/plan/meta/active`;
export const PLAN_FOLDERS = () => `${Api}/ged/folders`;
export const GED_DOCUMENT_LIST = () => `${Api}/ged/documents`;
export const GED_METADATA_QUALITY = () => `${Api}/ged/metadata-quality`;
export const GED_DOCUMENT_METADATA_QUALITY = (id) => `${Api}/ged/documents/${id}/metadata-quality`;
export const GED_METADATA_PROPOSAL = (id) => `${Api}/ged/documents/${id}/metadata-quality/proposal`;
export const GED_METADATA_DECISION = (id) => `${Api}/ged/documents/${id}/metadata-quality/decision`;
export const GED_DOCUMENT_CREATE = () => `${Api}/ged/documents`;
export const GED_DOCUMENT_ADD_VERSION = (id) => `${Api}/ged/documents/${id}/versions`;
export const GED_DOCUMENT_WORKFLOW = (id) => `${Api}/ged/documents/${id}/workflow`;
export const GED_DOCUMENT_DETAIL = (id) => `${Api}/ged/documents/${id}`;
export const GED_DOCUMENT_DETAIL_UUID = (uuid) => `${Api}/ged/documents/uuid/${uuid}`;
export const GED_DOCUMENT_UPDATE = (id) => `${Api}/ged/documents/${id}`;
export const GED_DOCUMENT_DOWNLOAD = (id) => `${Api}/ged/documents/${id}/download`;
export const GED_DOCUMENT_VIEW = (id) => `${Api}/ged/documents/${id}/view`;
export const GED_DOCUMENT_INTEGRITY = (id) => `${Api}/ged/documents/${id}/integrity`;
export const GED_DOCUMENT_EVENTS_EXPORT = (id) => `${Api}/ged/documents/${id}/events/export`;
export const GED_DOCUMENT_EVENTS = (id) => `${Api}/ged/documents/${id}/events`;
export const GED_DOCUMENT_TRASH = () => `${Api}/ged/documents/trash`;
export const GED_DOCUMENT_DELETE = () => `${Api}/ged/documents/delete`;
export const GED_DOCUMENT_RESTORE = () => `${Api}/ged/documents/restore`;
export const GED_EVENTS_LOGS = () => `${Api}/ged/events`;
export const GED_EVENTS_LOGS_EXPORT = () => `${Api}/ged/events/export`;
export const GED_DOCUMENT_IMPORT_ZIP = () => `${Api}/ged/documents/import-zip`;
export const GED_DOCUMENT_VALIDATE_BATCH = () => `${Api}/ged/documents/workflow/batch`;
export const GED_DOCUMENT_IMPORT_ZIP_PREVIEW = () => `${Api}/ged/documents/import-zip/preview`;
export const GED_DOCUMENT_SEARCH_ADVANCED = () => `${Api}/ged/documents/search-advanced`;
export const GED_OCR_PREVIEW = () => `${Api}/ged/ocr/preview`;
export const ARCHIVE_PROFILES = () => `${Api}/ged/profiles`;
export const ARCHIVE_PROFILE_CREATE = () => `${Api}/ged/profiles`;
export const ARCHIVE_PROFILE_IMPORT_FILE = () => `${Api}/ged/profiles/import-file`;
export const ARCHIVE_PROFILE_EXPORT_FILE = () => `${Api}/ged/profiles/export-file`;
export const REGLES_CONSERVATION = () => `${Api}/ged/regles-conservation`;
export const REGLES_CONSERVATION_IMPORT_ZIP = () => `${Api}/ged/regles-conservation/import-zip`;
export const REGLE_CONSERVATION = (id) => `${Api}/ged/regles-conservation/${id}`;
